"use strict";

var EventEmitter = require('events').EventEmitter;
var assign = require("object-assign");

var CHANGE_EVENT = 'change';

var BaseStore = assign({}, EventEmitter.prototype, {
  dispatchToken: null,
  addChangeListener: function (callback) {
    this.on(CHANGE_EVENT, callback);
  },

  removeChangeListener: function (callback) {
    this.removeListener(CHANGE_EVENT, callback);
  },

  emitChange: function () {
    this.emit(CHANGE_EVENT);
  }
});


module.exports = BaseStore;



// WEBPACK FOOTER //
// ./src/stores/baseStore.js